<ng-container *ngIf="isPerksModuleEnabled && isPerkLoaded && perks && perks.length">
  <div class="cta-container" *ngIf="!singlePerk; else singleSection">
    <div class="cta-cards-container">
      <div class="row">
        <ng-container *ngFor="let perk of perks">
          <div class="mb-3" [class.col-lg-6]="perks?.length === 2 && !isMobile" [class.col-lg-4]="perks?.length > 2 || isMobile">
            <pgh-perk
              [perk]="perk"
              [count]="perks?.length"
              [isMobile]="isMobile"
              [isPartnerLabelActive]="isPartnerLabelActive"
              (tutorialClicked)="openTutorial($event)">
            </pgh-perk>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <ng-template #singleSection>
    <div class="cta-secondary-container" *ngIf="singlePerk">
      <div class="image-col">
        <adp-setting [key]="singlePerk + '_SvgIcon'"></adp-setting>
        <div class="image" *ngIf="singlePerkSvgIcon">
          <mat-icon [svgIcon]="singlePerkSvgIcon"></mat-icon>
        </div>
        <div class="d-flex align-items-center mr-3" *ngIf="!singlePerkSvgIcon">
          <adp-image class="device-img" [imageKey]="'Global_' + singlePerk + '_Image'"></adp-image>
        </div>
      </div>
      <div class="content-col">
        <div>
          <h3 class="header-text">
            <adp-label [labelKey]="singlePerk + '_Heading'"></adp-label>
          </h3>
        </div>
        <div>
          <div class="sub-text">
            <adp-label [labelKey]="singlePerk"></adp-label>
          </div>
          <adp-setting [key]="singlePerk + '_Button_OpenInNewWindow'"></adp-setting>
          <adp-setting [key]="'URL_' + singlePerk"></adp-setting>
          <a
            *ngIf="singlePerkButtonRoute && !isTutorial"
            [target]="singlePerkButtonOpenInNewWIndow ? '_blank' : '_self'"
            class="cta-link"
            [routerLink]="[singlePerkButtonRoute]">
            <adp-label [labelKey]="singlePerk + '_Button'"></adp-label>
          </a>
          <ng-container *ngIf="singlePerkButtonRoute && isTutorial">
            <button class="link pl-0" (click)="openTutorial(perkButtonAria)" sf-aria-label="Global_Close_Window">
              <adp-label [labelKey]="singlePerk + '_Button'"></adp-label>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
